module.exports = __webpack_public_path__ + "img/jiejing1.97c0c9a9.png";